import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { PRODUCTION_ORDER_BREAKDOWN, } from '../types/production-order-breakdown.js';
/**
 * Descriptor for ProductionOrderBreakdown (planned size rows under an OP).
 * Subcollection: org/{orgId}/production-order/{productionOrderId}/breakdown
 *
 * Resolve repository with context: { orgId, productionOrderId }.
 */
export const productionOrderBreakdownDescriptor = {
    name: PRODUCTION_ORDER_BREAKDOWN,
    label: 'Grade planejada da OP',
    domain: 'production',
    collectionPath: 'org/{orgId}/production-order/{productionOrderId}/breakdown',
    pathPatternKeys: {
        orgId: 'string',
        productionOrderId: 'string',
    },
    version: 1,
    description: 'Size distribution of a production order — full ProductVariant per size (spec 0040 §2.2)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'productionOrderId',
            label: 'Ordem de produção',
            type: 'string',
            required: true,
            description: 'Parent production order id (also encoded in the path)',
        },
        {
            name: 'variantId',
            label: 'Variante',
            type: 'string',
            required: true,
            description: 'Full ProductVariant (includes size)',
        },
        {
            name: 'quantity',
            label: 'Quantidade',
            type: 'number',
            required: true,
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Variante completa (com tamanho)',
        },
        {
            fieldName: 'productionOrderId',
            targetEntity: 'ProductionOrder',
            relationship: 'many-to-one',
            displayField: 'code',
            description: 'Ordem de produção pai',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=production-order-breakdown.descriptor.js.map